import { Reveal } from "./Reveal";
import { FAQS } from "@/lib/data";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="mx-auto max-w-3xl px-4 py-24 sm:px-6 lg:py-32">
      <Reveal className="text-center">
        <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400/90">Before You Ask</p>
        <h2 className="font-display mt-3 text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Every question, answered
        </h2>
      </Reveal>
      <Reveal delay={0.1} className="mt-10">
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={f.q}
              value={`item-${i}`}
              data-testid={`faq-accordion-item-${i}`}
              className="rounded-2xl border border-white/10 bg-[#131a29] px-6 data-[state=open]:border-cyan-400/30"
            >
              <AccordionTrigger className="py-5 text-left text-base font-semibold text-white hover:text-cyan-300 hover:no-underline">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="pb-5 text-sm leading-relaxed text-slate-400">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </section>
  );
}
